<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <section id="ngx-datatable-shipping">
      <div class="card">
      <div
          class="card-title d-flex justify-content-between align-items-center"
        >
          <h4>Despachos a repartidores</h4>
          <div>
            <!--<button
              class="btn btn-info mr-1"
              rippleEffect
              [routerLink]="['/pages/bash-to-flight']"
            >
              <i data-feather="clipboard" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block">A Vuelo en Lote </span>
            </button>
            <button
              class="btn btn-primary mr-1"
              rippleEffect
              [routerLink]="['/pages/bill-batch-create']"
            >
              <i data-feather="plus" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block">Lote de Facturas</span>
            </button>
            <button type="button" [disabled]="this.fd.dealerId.value == null" class="btn btn-primary mr-1 text-nowrap" rippleEffect (click)="FetchModels()">
              <i data-feather="plus" class="mr-0 mr-sm-1"></i
                ><span class="d-none d-sm-inline-block text-nowrap">Cargar Facturas</span>
            </button>-->
            <button type="button" placement="left"
                class="btn btn-icon btn-info pl-2 text-danger cursor-pointer mr-50"
                
                height="16"
                rippleEffect 
                [ngbPopover]="popoverTemplate"
                #popOver="ngbPopover"
placement="left-top"
[autoClose]="'outside'">
                <span>
                    <i class="fa fa-bars fa-lg" style="color:#ffff"></i>                    
                    Filtrar                   
                  </span></button>  
            <button
              class="btn btn-primary mr-1 text-nowrap"              
              rippleEffect [routerLink]="'/pages/assignment/create-dispatch/'"                                     
            >
            <i data-feather="plus" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block text-nowrap">Crear Despacho</span>
            </button>
            <!--<button
              class="btn btn-warning mr-1 text-nowrap"
              rippleEffect   
              [routerLink]="'/pages/assignment/create-dispatch/' + this.selectedDealerId"
                                                            
            >
            <i data-feather="plus" class="mr-0 mr-sm-1"></i
              ><span class="d-none d-sm-inline-block text-nowrap">Ver Despachos</span>
            </button>   -->   
                        
            
          </div>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-md-6 col-12">
              <div
                class="d-flex justify-content-between align-items-center m-1"
              >
                <label class="d-flex align-items-center"
                  >Mostrando
                  <select
                    class="form-control mx-25"
                    [(ngModel)]="basicSelectedOption"
                  >
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option [value]="dispatchs.length">
                      Todos
                    </option>
                  </select>
                  facturas</label
                >
              </div>
            </div>
            <div class="col-md-6 col-12 d-flex justify-content-md-end">
              <div
                class="hidden d-flex align-items-center justify-content-end pr-1 pb-1 pl-1 pl-md-0 pb-md-0"
              >
                <label class="d-flex align-items-center"
                  >Buscar<input
                    #searchInput
                    type="search"
                    placeholder="Código Factura"
                    class="form-control ml-25"                    
                /></label>
              </div>
            </div>
          </div>        
        <ngx-datatable #myTable ngx-resize-watcher [rows]="dispatchs" [count]="totalRecords" [externalPaging]="true" [headerHeight]="40" [rowHeight]="50" class="bootstrap core-bootstrap expandable"
          [columnMode]="ColumnMode.force" [footerHeight]="40"
          [limit]="basicSelectedOption"
          [messages]="{emptyMessage: 'No hay información para mostrar', totalMessage: 'Total de facturas'}">
          <ngx-datatable-row-detail [rowHeight]="getHeight" #myDetailRow>
            <ng-template let-row="row" let-expanded="expanded" ngx-datatable-row-detail-template>
              <div style="padding-left:35px;">
                
                <div *ngFor="let shippingType of (row.dispatchBills | keyvalue)">
                  <table class="table table-striped pt-2">
                    <thead>
                      <tr>
                        <th scope="col" colspan="7">
                          <label> {{ shippingType.key }}</label>
                        </th>
                      </tr>
                      <tr>                        
                        <th scope="col">Código</th>
                        <th scope="col">Peso (lbs)</th>
                        <th scope="col">A Pagar</th>
                        <th scope="col">Municipio</th>    
                        <th scope="col">Acciones</th>       
                      </tr>
                      <tr *ngIf="row.dispatchBills?.length === 0">
                        <th scope="col" colspan="7">
                          <label>Sin información</label>
                        </th>
                      </tr>
                    </thead>
                    <tbody>                      
                      <tr *ngFor="let oper of shippingType.value">                        
                        <td class="table-cell">{{oper?.code}} <span *ngIf="oper.serviceCode"><br>{{ oper.serviceCode }}</span></td>
                        <td class="table-cell">{{oper?.pounds }}</td>
                        <td class="table-cell">{{oper?.total | number: '1.2-2' }}</td>
                        <td class="table-cell">{{oper?.customerModel.City.Name }}</td>  
                        <td class="table-cell"><button *ngIf="oper.stateCatalogId == 5" type="button" ngbTooltip="Eliminar" placement="left" (click)="DeleteBillInDispatch(oper.idCodes)"
                          class="btn-sm btn-icon btn-outline-danger text-danger cursor-pointer mr-50" rippleEffect>
                          <span [data-feather]="'delete'"></span></button>   
                        </td>         
                      </tr>
                    </tbody>
                    <tfoot>
                      <tr>
                        <td scope="col" colspan="5">
                          <div class="d-flex align-items-center justify-content-start pr-1 pb-1 pl-1 pl-md-0 pb-md-0">
                            <div style="font-weight: bold; padding-right: 2px;">Total de facturas: </div> <span style="padding-right: 2px;">{{ shippingType.value.length }}</span> | <div style="font-weight: bold; padding-right: 2px; padding-left: 2px">Total a pagar: </div>
                            <span style="padding-right: 2px;">{{GetTotalPaid(shippingType.value) | number: '1.2-2'}}</span>
                          </div>
                        </td>
                      </tr>
                    </tfoot>
                  </table> 
                </div>
                                  
                
              </div>
            </ng-template>
          </ngx-datatable-row-detail>
        

          <ngx-datatable-column [width]="50" [resizeable]="false" [sortable]="false" [draggable]="false"
            [canAutoResize]="false">
            <ng-template let-row="row" let-expanded="expanded" ngx-datatable-cell-template>
              <a href="javascript:void(0)" [class.datatable-icon-right]="!expanded" [class.datatable-icon-down]="expanded"
                title="Expand/Collapse Row" (click)="toggleExpandRow(row)">
              </a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [width]="100" name="Nombre" prop="name">
            <ng-template let-name="value" ngx-datatable-cell-template>
              <span placement="right" [ngbTooltip]="name">{{ name | limitText }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [width]="155" name="Creado" prop="createAt">
            <ng-template let-createAt="value" ngx-datatable-cell-template>
              <span>{{ createAt | date : "dd/MM/yyyy HH:mm" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [width]="148" name="Repartidor" prop="dealer">
            <ng-template let-dealer="value" ngx-datatable-cell-template>
              <div placement="left" [ngbTooltip]="dealer.userName">
                <span class="d-inline-block text-truncate" style="max-width: 145px;">
                  {{dealer.userName }}</span>
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [width]="150" name="Estado" prop="status">
            <ng-template let-status="value" ngx-datatable-cell-template>
              <div *ngIf="status == 1" class="badge badge-light-primary mx-1">
                Creado
              </div>
              <div *ngIf="status == 2" class="badge badge-primary mx-1">
                Recibido
              </div>
              <div *ngIf="status == 3" class="badge badge-secondary mx-1">
                Entregado
              </div>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [width]="148" name="Recibido" prop="receivedByDealerAt">
            <ng-template let-received="value" ngx-datatable-cell-template>
              <span>{{ ConvertDate(received) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [width]="148" name="Entregado" prop="deliveredAt">
            <ng-template let-deliveredAt="value" ngx-datatable-cell-template>
              <span>{{ ConvertDate(deliveredAt) }}</span>
            </ng-template>
          </ngx-datatable-column>
        
          <ngx-datatable-column name="Acciones" [width]="'auto'" [sortable]="false" prop="accions">
            <ng-template ngx-datatable-cell-template let-accions="value">
              <button class="btn btn-outline-light text-primary dropbtn" [ngbPopover]="popoverTemplate" #popOver="ngbPopover"
                data-container="body" placement="left-top" [autoClose]="'outside'" type="button" id="defaultDropdown"
                aria-expanded="false">
                <em class="fa fa-bars"></em>
              </button>
              <ng-template #popoverTemplate style="overflow: visible;">
                <div>
                  <button type="button" *ngIf="accions.status !== 3" ngbTooltip="Eliminar" placement="left" (click)="DeleteDispatch(accions.id)"
                    class="btn btn-icon btn-outline-danger text-danger cursor-pointer mr-50" rippleEffect>
                    <span [data-feather]="'delete'"></span></button>
                  <button type="button" *ngIf="accions.status !== 3" ngbTooltip="Actualizar" placement="left" [routerLink]="'/pages/assignment/create-dispatch/' + accions.id"
                    class="btn btn-icon btn-outline-info text-info cursor-pointer mr-50" rippleEffect>
                    <span [data-feather]="'edit'"></span></button>
                    <button type="button" ngbTooltip="Imprimir" placement="left" (click)="exportDispatch(accions.id)" 
                    class="btn btn-icon btn-outline-primary text-primary cursor-pointer mr-50" rippleEffect>
                    <span [data-feather]="'printer'"></span></button>                    
                </div>
              </ng-template></ng-template>
          </ngx-datatable-column>
          <ngx-datatable-footer *ngIf="true">
            <ng-template ngx-datatable-footer-template let-rowCount="rowCount" let-pageSize="pageSize"
              let-selectedCount="selectedCount" let-curPage="curPage" let-offset="offset">
              <div class="d-flex justify-content-between w-100">
                <div class="col-7 col-lg-7 col-sm-7" style="padding: 5px 10px">
                  <div>Total despachos: {{ rowCount }} <!--| Total libras: {{ totalPounds() | number :'1.2-2' }} | Total cobrado: {{
                    totalPaid() | currency}}--></div>
                </div>
                <div class="col-5 col-lg-5 col-sm-5 align-items-center align-self-end text-right text-nowrap">
                  <datatable-pager [pagerLeftArrowIcon]="'datatable-icon-left'" [pagerRightArrowIcon]="'datatable-icon-right'"
                                [pagerPreviousIcon]="'datatable-icon-prev'" [pagerNextIcon]="'datatable-icon-skip'" [page]="page"
                                [visiblePagesCount]="currentVisible" [size]="basicSelectedOption" [count]="totalRecords"
                                (change)="onPageChange($event)">
                            </datatable-pager>
                </div>
              </div>
        
        
        
        
            </ng-template>
          </ngx-datatable-footer>
        </ngx-datatable>
        <ng-template #detailTemplate let-row="row">
          <ngx-datatable
            class="nested-datatable"
            [rows]="row.details"
            [columnMode]="'force'"
            [headerHeight]="50"
            [footerHeight]="50"
            [rowHeight]="'auto'"
          >
            <ngx-datatable-column name="Detail ID" prop="detailId"></ngx-datatable-column>
            <ngx-datatable-column name="Description" prop="description"></ngx-datatable-column>
          </ngx-datatable>
        </ng-template>
        <ng-template #popoverTemplate> 
          <div class="col-md-12 col-12">
              <div class="row pb-1">
                  <div class="col-md-12">
                      <button type="button" class="close" (click)="popOver.close()" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                      </button>
                  </div>              
              </div>                     
              <div class="modal-body" tabindex="0" ngbAutofocus>
                <form [formGroup]="filterForm"  id="accountInformationForm">                  
                    <div class="row">
                      <div class="col-md-4">
                        <label class="form-label" for="vertical-language">
                          <b class="text-primary">*</b> Repartidores
                        </label>
                        <ng-select
                          [items]="dealers"
                          bindLabel="userName"
                          bindValue="id"
                          formControlName="dealerId"                          
                        >
                        </ng-select>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label class="form-label" for="fecha-input">
                              <b class="text-primary">*</b> Desde: 
                          </label>
                          <div class="input-group">
                            <input class="form-control"
                            
                            outsideDays="hidden"
                            
                            tabindex="-1"
                             placeholder="mm/dd/yyyy" name="Fecha" formControlName="startDate"
                                  ngbDatepicker #basicDPD="ngbDatepicker" aria-describedby="date-input"                
                                  readonly />
                              <div class="input-group-append">
                                  <button class="btn btn-outline-secondary feather icon-calendar" (click)="basicDPD.toggle()"
                                      type="button" rippleEffect></button>
                              </div>
                             
                          </div>        
                      </div>
                      </div>  
                      <div class="col-md-4">
                        <div class="form-group">
                          <label class="form-label" for="code">
                            Código Factura
                          </label>
                          <input type="text" id="code" class="form-control"
                             formControlName="code" />    </div>
                      </div>                        
                    </div>      
                    <div class="row pt-2 pb-2">
                      <div class="col-md-4">
                        <button class="btn btn-outline-primary" type="button" rippleEffect (click)="resetFilters()"      
                        >Borrar filtros</button>
                      </div>
                      <div class="col-md-4">
                  
                      </div>
                      <div class="col-md-4">
                        <button class="btn btn-primary" type="button" rippleEffec (click)="FilterDispatchs()"      
                        >Buscar</button>
                      </div>
                    </div>            
                </form>
              </div>
          </div>               
                                           
        </ng-template>
      </div>
    </div>
    </section>
  </div>
</div>
